// directives/tooltip.js
import { getTooltipInstance } from '@/components/GlobalTooltip.vue'

export function createTooltipDirective() {
  return {
    mounted(el, binding) {
      // Получаем экземпляр через экспортированную функцию
      let tooltipInstance = getTooltipInstance()

      // Если не нашли, пробуем через window
      if (!tooltipInstance && typeof window !== 'undefined') {
        tooltipInstance = window.__globalTooltip
      }

      if (!tooltipInstance) {
        // Пробуем найти в DOM
        const tooltipEl = document.querySelector('.global-tooltip')
        if (tooltipEl?.__vnode?.ctx) {
          tooltipInstance = tooltipEl.__vnode.ctx
        }
      }

      if (!tooltipInstance) {
        console.warn('GlobalTooltip not found. Make sure <GlobalTooltip /> is in your App.vue')
        return
      }

      setupTooltip(el, binding, tooltipInstance)
    },

    updated(el, binding) {
      const tooltipInstance = getTooltipInstance() || window.__globalTooltip
      if (!tooltipInstance) return

      // Если директива отключена
      if (binding.value?.disabled && el._tooltipCleanup) {
        cleanupTooltip(el)
        return
      }

      // Если изменился контент
      if (binding.value !== binding.oldValue && el._tooltipCleanup) {
        cleanupTooltip(el)
        setupTooltip(el, binding, tooltipInstance)
      }
    },

    unmounted(el) {
      cleanupTooltip(el)
    }
  }
}

function setupTooltip(el, binding, tooltipInstance) {
  let config = typeof binding.value === 'object'
    ? binding.value
    : { content: binding.value }

  const {
    content,
    delay = 380,
    showOnClick = false,
    disabled = false
  } = config

  if (disabled) return

  const getContent = typeof content === 'function' ? content : () => content

  const handlers = tooltipInstance.attachToElement(
    el,
    getContent,
    { delay, showOnClick }
  )

  el._tooltipCleanup = handlers.detach
  el._tooltipHandlers = handlers
}

function cleanupTooltip(el) {
  if (el._tooltipCleanup) {
    el._tooltipCleanup()
    delete el._tooltipCleanup
    delete el._tooltipHandlers
  }
}